const Nihilus = () => {
	return <h1>Nihilus</h1>;
  };
  
  export default Nihilus;